import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion"

import { useTranslate } from "context/translateContext"
import Panel from "shared/components/Panel/Panel"

import styles from "./FAQ.module.css"

const FAQ = () => {
  const { t: translate } = useTranslate()

  const items = [
    {
      id: "accordion1",
      heading: translate(
        "What is the difference between Webinterpret listings and domestic listings?"
      ),
      content: translate(
        "Webinterpret listings refer to any listing created by Webinterpret through the Internationalization service. A domestic listing is defined as any listing not produced by Webinterpret and appearing in your domestic market."
      ),
    },
    {
      id: "accordion2",
      heading: translate("How long is the free trial period?"),
      content: translate(
        "The free trial period is 30 days (for eBay and Amazon marketplaces) and includes access to the Internationalization service. Up to 50% of your eligible listings will be localized and placed on international eBay and/or Amazon marketplaces (United Kingdom, United States, Australia, Germany, France, Italy, Spain). For eBay, the number of listings may depend on your eBay store subscription. For Amazon, no more than 100 listings per site will be localized."
      ),
    },
    {
      id: "accordion3",
      heading: translate("How do success fees and transaction fees work?"),

      content: (
        <>
          <p>
            {translate(
              "Success fees are charged as a percentage of sales generated by the listings created by Webinterpret. Sellers with over 50% of their products in the technology hardware category may benefit from a lower success fee of 2.9%."
            )}
          </p>
          <p>
            {translate(
              "Transaction fees are charged as a fixed amount for each of the transactions generated by the listings created by Webinterpret."
            )}
          </p>
          <p>
            {translate(
              "Specified success and transaction fees for Starter and Business plan subscribers apply only to international orders generated by Webinterpret."
            )}
          </p>
        </>
      ),
    },
    {
      id: "accordion4",
      heading: translate(
        "Are there any site, service, or marketplace restrictions?"
      ),

      content: (
        <>
          <p>
            {translate(
              "Available eBay sites include Austria, Australia, Belgium, France, Germany, Italy, Spain, Ireland, Canada (EN and FR), the United States, the United Kingdom, and eBay Motors. The eBay sites in Belgium and Austria require activation from the Webinterpret Dashboard and may result in fewer zero insertion fee listings."
            )}
          </p>
          <p>
            {translate(
              "Available Amazon sites include France, Germany, Italy, Spain, and the United Kingdom."
            )}
          </p>
          <p>
            {translate(
              "Webinterpret Advertising (Promoted Listings Advanced) is not yet available for eBay Spain."
            )}
          </p>
          <p>
            {translate(
              "Webinterpret Advertising and Returns are not yet available for Amazon."
            )}
          </p>
        </>
      ),
    },
  ]

  return (
    <Panel className={styles.panel}>
      <div className={styles.panelHeader}>
        {translate("Frequently Asked Questions")}
      </div>
      <Accordion allowMultipleExpanded allowZeroExpanded>
        {items.map(item => (
          <AccordionItem key={item.id} className={styles.section}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <h4>
                  <span>{item.heading}</span>
                  <span className={styles.accordionIcon}>
                    <AccordionItemState>
                      {({ expanded }) => (expanded ? "-" : "+")}
                    </AccordionItemState>
                  </span>
                </h4>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className={styles.accordionContent}>{item.content}</div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Panel>
  )
}

export default FAQ
